import { render, staticRenderFns } from "./BadgeCustomerList.vue?vue&type=template&id=a2b7b1ec&"
import script from "./BadgeCustomerList.vue?vue&type=script&lang=js&"
export * from "./BadgeCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports